<script>
import {Doughnut, mixins} from "vue-chartjs";
import addCommas from "../functions/addCommas";

const { reactiveProp } = mixins;

export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            required: true
        },
        headline: {
            type: String,
            default: "-"}
    },
    data() {
        return {
            options: {
                maintainAspectRatio: true,
                legend: {
                    position: "bottom",
                    onClick: e => e.stopPropagation()
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return addCommas(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
                        }
                    }
                }
            }
        };
    },
    computed: {
        name() {
            return this.data 
        },
    },
    watch: {
        headline: function (val) {
              this.textCenter(val);
        },
    },
    mounted() {
        this.textCenter(this.headline);
        this.renderChart(this.chartData, this.options);
    },
    methods: {
        textCenter(val) {
            Chart.pluginService.register({
                beforeDraw: function (chart) {
                    chart.clear()
                    var width = chart.chart.width;
                    var height = chart.chart.height - chart.legend.height;
                    var ctx = chart.chart.ctx;

                    ctx.restore();
                    var fontSize = (height / (12*19)).toFixed(2);
                    
                    ctx.font = fontSize + "em Nunito";
                    var text = val;
                    var textX = Math.round((width - ctx.measureText(text).width) / 2);
                    var textX2 = Math.round((width - ctx.measureText("Total").width) / 2);
                    var textY1 = height / 12 * 5.3;
                    var textY2 = height / 12 * 6.7;

                    ctx.fillText("Total:", textX2, textY1);
                    ctx.fillText(text, textX, textY2);
                    ctx.save();
                }
            });

            Chart.plugins.unregister(this.chartdata);
        }
    }
};
</script>
